import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "flex-ter"
}

import { t } from '@/plugins/i18n'

import { updateComCustomerSkuApi } from '@/apis/combined'
import { ElMessage } from 'element-plus'

export default /*#__PURE__*/_defineComponent({
  props: ['row'],
  setup(__props) {

const props = __props


const saveCustomerProductMsku = (row: any) => {
  const { combinationProductSku, customerProductMsku } = row
  row.loading = true
  updateComCustomerSkuApi({ combinationProductSku, customerProductMsku }).then((res:any) => {
    if (!res.success) return
    ElMessage.success(t('保存成功'))
  }).finally(() => {
    row.loading = false
    row.showCustomerProductMsku = false
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!

  return (__props.row.customerProductMsku && !__props.row.showCustomerProductMsku)
    ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.row.showCustomerProductMsku = true))
      }, _toDisplayString(__props.row.customerProductMsku), 1))
    : (!__props.row.customerProductMsku && !__props.row.showCustomerProductMsku)
      ? (_openBlock(), _createElementBlock("a", {
          key: 1,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (__props.row.showCustomerProductMsku = true))
        }, _toDisplayString(_unref(t)('填写')), 1))
      : (__props.row.showCustomerProductMsku)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_el_input, {
              modelValue: __props.row.customerProductMsku,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((__props.row.customerProductMsku) = $event)),
              size: "small",
              maxlength: "100"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_el_button, {
              style: {"margin-left":"4px"},
              loading: __props.row.loading,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (saveCustomerProductMsku(__props.row))),
              size: "small"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('保存')), 1)
              ]),
              _: 1
            }, 8, ["loading"])
          ]))
        : _createCommentVNode("", true)
}
}

})